<template>
  <div>
    <dictionary-modal-table
      dictionary_link="/certificates"
      title="Lista certyfikatów"
      :numeral_text="['certyfikat', 'certyfikaty', 'certyfikatów']"
      :columns_title="['name', 'icon']"
    ></dictionary-modal-table>
  </div>
</template>

<script>
import DictionaryModalTable from "./DictionaryModalTable.vue";
export default {
  components: {
    DictionaryModalTable,
  },
};
</script>
